import { render, staticRenderFns } from "./Protocole.vue?vue&type=template&id=e6e2e6ee&scoped=true&"
import script from "./Protocole.vue?vue&type=script&lang=js&"
export * from "./Protocole.vue?vue&type=script&lang=js&"
import style0 from "./Protocole.vue?vue&type=style&index=0&id=e6e2e6ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e2e6ee",
  null
  
)

export default component.exports